/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CancelOrganisationMembershipInvitationMutationVariables = Types.Exact<{
  organisationMembershipInvitationId: Types.Scalars['ID']['input'];
}>;


export type CancelOrganisationMembershipInvitationMutation = { cancelOrganisationMembershipInvitation: { __typename: 'CancelOrganisationMembershipInvitationResult', invitation: { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus } } };


export const CancelOrganisationMembershipInvitationDocument = gql`
    mutation CancelOrganisationMembershipInvitation($organisationMembershipInvitationId: ID!) {
  cancelOrganisationMembershipInvitation(
    organisationMembershipInvitationId: $organisationMembershipInvitationId
  ) {
    invitation {
      id
      status
    }
  }
}
    `;
export type CancelOrganisationMembershipInvitationMutationFn = Apollo.MutationFunction<CancelOrganisationMembershipInvitationMutation, CancelOrganisationMembershipInvitationMutationVariables>;

/**
 * __useCancelOrganisationMembershipInvitationMutation__
 *
 * To run a mutation, you first call `useCancelOrganisationMembershipInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrganisationMembershipInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrganisationMembershipInvitationMutation, { data, loading, error }] = useCancelOrganisationMembershipInvitationMutation({
 *   variables: {
 *      organisationMembershipInvitationId: // value for 'organisationMembershipInvitationId'
 *   },
 * });
 */
export function useCancelOrganisationMembershipInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrganisationMembershipInvitationMutation, CancelOrganisationMembershipInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrganisationMembershipInvitationMutation, CancelOrganisationMembershipInvitationMutationVariables>(CancelOrganisationMembershipInvitationDocument, options);
      }
export type CancelOrganisationMembershipInvitationMutationHookResult = ReturnType<typeof useCancelOrganisationMembershipInvitationMutation>;
export type CancelOrganisationMembershipInvitationMutationResult = Apollo.MutationResult<CancelOrganisationMembershipInvitationMutation>;
export type CancelOrganisationMembershipInvitationMutationOptions = Apollo.BaseMutationOptions<CancelOrganisationMembershipInvitationMutation, CancelOrganisationMembershipInvitationMutationVariables>;